import React from 'react'
import { CreditApplication } from '_gql'

import { useMakeTestId } from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'

import { StatusButtons } from '@sputnik/components'
import ImageWrapper from '@sputnik/components/ImageWrapper'
import useGoToOffers from '@sputnik/hooks/useGoToOffers'
import StatusTile from '@sputnik/pages/Dashboard/StatusTile/StatusTile'

interface InReviewSubmittedStatusTileProps {
  creditApp: CreditApplication
  moreInfoInReview?: boolean
}

// This tile shows for IN_REVIEW or SUBMITTED status OR if MORE_INFO_NEEDED status and all documents are uploaded
const InReviewSubmittedStatusTile = ({ creditApp, moreInfoInReview }: InReviewSubmittedStatusTileProps) => {
  const makeTestId = useMakeTestId('InReviewSubmittedStatusTile')

  const { lastUpdatedByApplicantAt, salesforceCreditId, authorizedSigner } = creditApp || {}
  const { decisions, handleGoToOffers, isLoggedInUserAuthorizedSigner } = useGoToOffers({
    salesforceCreditId,
    authSignerEmail: authorizedSigner?.email as string,
  })
  const hasSelectedDecision = !!decisions?.find((decision) => decision.userSelectedAt)
  const showGoToOfferButton = isLoggedInUserAuthorizedSigner && decisions?.length > 0 && !hasSelectedDecision

  return (
    <div data-testid={makeTestId('')}>
      <StatusTile
        creditApp={creditApp}
        image={
          <ImageWrapper
            alt='person look at a document'
            imageName='dashboard-application-in-review-status'
          />
        }
        moreInfoInReview={moreInfoInReview}
        primaryInfo={
          <FormattedMessage
            defaultMessage='We will contact you shortly if we need additional information. {showGoToOfferButton, select, 
            true {In the meantime, you can review and sign your offer.}
            other {}}'
            id='sputnik.InReviewSubmittedStatusTile__B5W6N1'
            values={{ showGoToOfferButton }}
          />
        }
        secondaryInfo={
          <FormattedMessage
            defaultMessage='Submitted on {date, date, long}'
            id='sputnik.InReviewSubmittedStatusTile__nklYpE'
            values={{ date: new Date(lastUpdatedByApplicantAt) }}
          />
        }
        title={
          <FormattedMessage
            defaultMessage='Application under review'
            id='sputnik.InReviewSubmittedStatusTile__05muiR'
          />
        }
      >
        {showGoToOfferButton && (
          <StatusButtons
            hideSecondary
            primaryText={
              <FormattedMessage
                defaultMessage='Go to {offers, plural, one {offer} other {offers}}'
                id='sputnik.InReviewSubmittedStatusTile__flDVZF'
                values={{ offers: decisions?.length }}
              />
            }
            onPrimaryClick={handleGoToOffers}
          />
        )}
      </StatusTile>
    </div>
  )
}

export default InReviewSubmittedStatusTile
